module.exports = __webpack_public_path__ + "img/mitsu-new.4e8b13b8.png";